export default {
  // 当前使用的摄像头设备Id
  activeCameraId(playerState) {
    return playerState.activeCamera.deviceId;
  },
  // 当前使用的摄像头设备Id
  activeMicrophoneId(playerState) {
    return playerState.activeMicrophone.deviceId;
  },
  // 当前使用的扬声器设备Id
  activeSpeakerId(playerState) {
    return playerState.activeSpeaker.deviceId;
  },
  // 音视频流是否正在播放中
  isPlaying(playerState) {
    return playerState.playState === 'playing';
  },
  // 音视频流是否正在暂停中
  isPaused(playerState) {
    return playerState.playState === 'paused';
  },

  // 判断是否是图文直播
  isTuWenLiving(playerState) {
    return playerState.liveType === 1;
  },

  // 判断视频直播，并且是否开启图文直播
  isVideoAndGraphic(playerState) {
    return playerState.liveType === 0 && playerState.liveGraphic === true;
  },
};
